var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mr-2 ml-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nombre",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(50),
                    _vm.rules.specialCharacters(),
                    _vm.rules.allowLettersExclusively()
                  ],
                  "prepend-icon": "mdi-account"
                },
                model: {
                  value: _vm.additionalPerson.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.additionalPerson, "firstName", $$v)
                  },
                  expression: "additionalPerson.firstName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Apellido",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(50),
                    _vm.rules.specialCharacters(),
                    _vm.rules.allowLettersExclusively()
                  ],
                  "prepend-icon": "mdi-account"
                },
                model: {
                  value: _vm.additionalPerson.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.additionalPerson, "lastName", $$v)
                  },
                  expression: "additionalPerson.lastName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mr-2 ml-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "########",
                    expression: "'########'"
                  }
                ],
                attrs: {
                  label: "Cédula de Identidad",
                  rules: [_vm.rules.required()],
                  "prepend-icon": "mdi-card-account-details"
                },
                model: {
                  value: _vm.additionalPerson.idNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.additionalPerson, "idNumber", $$v)
                  },
                  expression: "additionalPerson.idNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Empresa",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(250),
                    _vm.rules.specialCharacters()
                  ],
                  "prepend-icon": "mdi-office-building"
                },
                model: {
                  value: _vm.additionalPerson.company,
                  callback: function($$v) {
                    _vm.$set(_vm.additionalPerson, "company", $$v)
                  },
                  expression: "additionalPerson.company"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-row", [_c("v-divider", { staticClass: "mt-2" })], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }